const jobPostEdit = window.location.pathname.match(/\/franchise_jobs\/\d+/);

if (jobPostEdit) {
  document.addEventListener('DOMContentLoaded', function () {
    const totalPriceInput = document.getElementById('franchise_job_total_price');
    const fireFighterPayoutInput = document.getElementById('franchise_job_fire_fighter_pay_amount');
    const franchiseJobDetails = document.getElementById('franchise_job_details');
    const discountCouponSelect = document.getElementById('franchise_job_discount_coupon_id');
    const NON_DIGIT_REGEX = /\D/g

    if (totalPriceInput && fireFighterPayoutInput && franchiseJobDetails && discountCouponSelect) {
      const STRIPE_BASE_FEE = parseFloat(franchiseJobDetails.dataset.stripe_base_fee) || 0;
      const STRIPE_FEE = parseFloat(franchiseJobDetails.dataset.stripe_fee_percentage) || 0;

      // Targets
      const elBasePrice        = document.getElementById('aa-base-price');
      const elDiscountPercent  = document.getElementById('aa-discount-percent');
      const elDiscountAmount   = document.getElementById('aa-discount-amount');
      const elStripeFee        = document.getElementById('aa-stripe-fee');
      const elUserCharged      = document.getElementById('user-charged');
      const elPayout           = document.getElementById('aa-payout');
      const elFranchiseMargin  = document.getElementById('franchise-margin');

      const toCurrency = (n) => `$${Number.isFinite(n) ? n.toFixed(2) : '0.00'}`;
      const safeNumber = (el) => {
        const v = parseFloat(el.value);
        return Number.isFinite(v) ? Math.max(0, v) : 0;
      };

      function updateAmounts() {
        const selectedOption = discountCouponSelect.options[discountCouponSelect.selectedIndex];
        const DISCOUNT_PCT = parseFloat(selectedOption.dataset.discountPercentage) || 0;

        const basePrice = safeNumber(totalPriceInput);
        const payout = safeNumber(fireFighterPayoutInput);

        // Discount
        const discountAmount = +(basePrice * (DISCOUNT_PCT / 100)).toFixed(2);
        const discountedSubtotal = Math.max(0, +(basePrice - discountAmount).toFixed(2));

        let totalWithStripeFee;
        let stripeFee;
        let actualBasePrice;
        let franchiseMargin;

        if (discountedSubtotal === 0) {
          // if 100 % discount, no fees, no charge, fire_fighter_margin, negative franchise margin -> error when saving
          totalWithStripeFee = 0;
          stripeFee = 0;
          actualBasePrice = 0;
          franchiseMargin = -payout;
        } else {
          // work as before
          totalWithStripeFee = (discountedSubtotal + STRIPE_BASE_FEE) / (1 - STRIPE_FEE);
          totalWithStripeFee = Math.ceil(totalWithStripeFee * 100) / 100;

          stripeFee = +(totalWithStripeFee * STRIPE_FEE + STRIPE_BASE_FEE).toFixed(2);
          actualBasePrice = +(totalWithStripeFee - stripeFee).toFixed(2);
          franchiseMargin = +(totalWithStripeFee - stripeFee - payout).toFixed(2);
        }

        // Fill UI
        if (elBasePrice) elBasePrice.textContent = toCurrency(actualBasePrice + discountAmount);
        if (elDiscountPercent) elDiscountPercent.textContent = `${DISCOUNT_PCT}%`;
        if (elDiscountAmount) elDiscountAmount.textContent = toCurrency(discountAmount);
        if (elStripeFee) elStripeFee.textContent = toCurrency(discountedSubtotal > 0 ? stripeFee : 0);
        if (elUserCharged) elUserCharged.textContent = toCurrency(discountedSubtotal > 0 ? totalWithStripeFee : 0);
        if (elPayout) elPayout.textContent = toCurrency(payout);
        if (elFranchiseMargin) elFranchiseMargin.textContent = toCurrency(franchiseMargin);

        //  Warn if margin < 0
        if (elFranchiseMargin) {
          elFranchiseMargin.style.color = franchiseMargin < 0 ? 'crimson' : '';
          elFranchiseMargin.title = franchiseMargin < 0 ? 'Margin is negative' : '';
        }
      }

      updateAmounts();
      totalPriceInput.addEventListener('input', () => {
        updateAmounts();
        totalPriceInput.value = totalPriceInput.value.replace(NON_DIGIT_REGEX, '');
      });
      
      fireFighterPayoutInput.addEventListener('input', () => {
        updateAmounts();
        fireFighterPayoutInput.value = fireFighterPayoutInput.value.replace(NON_DIGIT_REGEX, '');
      });
      
      discountCouponSelect.addEventListener('change', updateAmounts);
    }
  });
}
